










import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Getter } from "vuex-class";

import ProgressSpinner from "@/components/ui/ProgressSpinner.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Form action button component
 */
@Component({
  components: { ProgressSpinner },
  filters: {
    ...capitalizeFilter
  }
})
export default class FormActionButton extends Vue {
  @Getter("ui/isAnyAliasedRequestPending")
  private isAnyAliasedRequestPending!: (alias: string) => boolean;
  @Prop() private requestAlias!: string;
  @Prop() private clickAction!: () => void;

  i18nMessageKeyEnum = I18nMessageKey;
}
